var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollectKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1095 11.8969L8.03444 6.52847C8.65541 5.36636 8.50015 3.87582 7.56872 2.89055C6.44621 1.70315 4.63113 1.70315 3.50863 2.89055C2.38612 4.07795 2.38612 5.99794 3.50863 7.18532C4.44007 8.17059 5.84916 8.33482 6.94777 7.67795L9.49129 10.3685L8.67932 11.2274C8.55987 11.3538 8.55987 11.5685 8.67932 11.6948L9.25248 12.3011C9.37193 12.4274 9.57492 12.4274 9.6943 12.3011L10.5063 11.4421L11.0078 11.9727L10.1958 12.8316C10.0764 12.9579 10.0764 13.1727 10.1958 13.2989L10.769 13.9052C10.8885 14.0316 11.0914 14.0316 11.2108 13.9052L12.0228 13.0463C12.3213 13.3621 12.8109 13.3621 13.1095 13.0463C13.408 12.7307 13.4081 12.2127 13.1095 11.8969Z",
    stroke: "#292B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73034 4.77054C4.87989 4.92875 5.12727 4.92875 5.27683 4.77054C5.43212 4.60623 5.43212 4.35067 5.27683 4.19246C5.12728 4.03426 4.8799 4.03426 4.73034 4.19246C4.58078 4.35066 4.58078 4.61234 4.73034 4.77054Z",
    stroke: "#292B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectKey);
export default __webpack_public_path__ + "static/media/collect-key.31cb1c586ef98e2c670a53b2c5d1b06a.svg";
export { ForwardRef as ReactComponent };